// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2R78e","header":"Messages_header__eXYp6"};